class ReportsManager {
  constructor(container, dateInput) {
    this.$container = jQuery(container);
    this.$dateInput = jQuery(dateInput);
    this.$container.data("manager", this);
    this.options = this.defaultOptions(this.$container.data("report-options"));
    this.state = "unloaded";
    this.init();
  }

  defaultOptions(options) {
    options.table = typeof options.table !== "undefined" ? options.table : true;
    options.graph = typeof options.graph !== "undefined" ? options.graph : true;
    return options;
  }

  init() {
    this.initDataErrorEvents();
    this.addTabListener();
    this.addDatePickerListener();

    if (this.options.graph) {
      this.initTooltip();
      this.addMetricMenuListener();
      this.addMetricGraphUpdater();
    }

    if (this.options.table) {
      var tabBuilder = new TabBuilder("tab-selectors tab-selectors--secondary", "tab-content");

      if (this.options.aggregate) {
        tabBuilder.addTab("Summary", jQuery('<div class="report-summary-table-container"></div>'), true);
      }
      tabBuilder.addTab("Detailed", jQuery('<div class="report-table-container"></div>'), !this.options.aggregate);
      this.$container.append(tabBuilder.nav, tabBuilder.contentHolder);

      if (this.options.aggregate) {
        this.addMetricSummaryTableUpdater();
      }
      this.addMetricTableUpdater();
    }

    this.refreshIfVisible();
  }

  initDataErrorEvents() {
    var messages = {
      title: "No data In this range",
      message: "Would you like to expand this range?",
      dateRangeButton: true,
    };

    this.$container.on("dataError:empty", (event, data) => {
      var container = this.$container.find(".report-graph-container");
      container.empty();
      container.append(`
        <div class="report-error-data-range ${data.reason}">
          <div class="report-error-image"></div>
          <h1>${messages.title}</h1>
          <p>${messages.message}</p>
          ${messages.dateRangeButton ? '<button class="btn --secondary report-error-date-range">Expand Range</button>' : ""}
        </div>
      `);

      this.$container.on("click", ".report-error-date-range", () => {
        this.$dateInput.daterangepicker("open");
      });
    });
  }

  refreshIfVisible() {
    if (this.$container.is(":visible")) {
      this.tooltip.hide();
      this.$container.find(".report-table-container").empty();
      this.$container.find(".report-graph-container").html(Sparkle.spinner);

      if (this.state == "unloaded") {
        this.loadMetricSummary();
      } else if (this.state == "summaryLoaded") {
        this.$container.trigger("report:refresh");
      }
    }
  }

  refreshGraphIfVisible() {
    if (this.$container.is(":visible") && this.metricGraph && this.metricGraph.data) {
      this.metricGraph.renderChart();
    }
  }

  addTabListener() {
    jQuery(document).on("tab:shown", () => {
      if (this.state == "unloaded") {
        this.refreshIfVisible();
      }
    });
  }

  addDatePickerListener() {
    this.$dateInput.on("change", () => {
      this.state = "unloaded";
      this.refreshIfVisible();

      var dateJSON = JSON.parse(this.$dateInput.val());
      var url = new URL(window.location.href);
      url.searchParams.set("report_range[start]", dateJSON["start"]);
      url.searchParams.set("report_range[end]", dateJSON["end"]);
      history.replaceState("", "", url.toString());
    });
  }

  loadMetricSummary() {
    this.$container.find(".report-metrics-container").empty();
    this.$container.find(".report-summary-table-container").empty();

    jQuery.getJSON(this.url("metric_summary"), (metrics) => {
      this.metricData = metrics;

      var selected = true;
      for (let metric in metrics) {
        new MetricSummary(this.$container.find(".report-metrics-container"), metric, metrics[metric], selected);
        selected = false;
      }

      this.state = "summaryLoaded";
      this.$container.trigger("report:refresh");
    });

    if (this.options.aggregate) {
      jQuery.get(this.url("metric_summary_table"), (response) => {
        this.$container.find('[data-tab-name="Summary"]').toggle(response.length > 0);
        this.$container.find(".report-summary-table-container").html(response);
      });
    }

    this.state = "summaryLoading";
  }

  addMetricGraphUpdater() {
    this.metricGraph = new MetricGraph(this);
    this.$container.on("report:refresh", () => {
      if (this.getDateRange().start == this.getDateRange().end) {
        this.$container.find(".report-graph-container").empty();
        return;
      }
      this.metricGraph.render(this.metricData[this.getReportType()].type);
    });

    jQuery(window).on("resize", () => {
      this.refreshGraphIfVisible();
    });
  }

  addMetricSummaryTableUpdater() {
    var table = this.$container.find(".report-summary-table-container");

    table
      .on("ajax:before", function () {
        table.css("opacity", 0.5);
      })
      .on("ajax:success", function (e, response) {
        table.html(response);
        table.css("opacity", 1);
      });
  }

  addMetricTableUpdater() {
    this.$container.on("report:refresh", () => {
      jQuery.get(this.url("metric_table"), (response) => {
        this.$container.find('[data-tab-name="Detailed"]').toggle(response.length > 0);
        this.$container.find(".report-table-container").html(response);
      });
    });

    var table = this.$container.find(".report-table-container");

    table
      .on("ajax:before", function () {
        table.css("opacity", 0.5);
      })
      .on("ajax:success", function (e, response) {
        table.html(response);
        table.css("opacity", 1);
      });
  }

  addMetricMenuListener() {
    this.$container.append('<form class="report-metrics-container"></form>');

    this.$container.on("change", "[data-behaviour=refresh-graph]", () => {
      this.refreshIfVisible();
    });
  }

  initTooltip() {
    this.tooltip = new ReportToolTip();
  }

  url(action) {
    return (
      this.$container.data("base-url") +
      "/" +
      action +
      "?" +
      this.reportParams() +
      "&" +
      window.location.search.slice(1)
    );
  }

  reportParams() {
    var params = {
      metrics: this.options.metrics,
      treat_user_as_agent: this.options.treat_user_as_agent,
      report_type: this.getReportType(),
      start_date: this.getDateRange().start,
      end_date: this.getDateRange().end,
    };

    if (window.RESOURCE) {
      params.resource_type = window.RESOURCE.type;
      params.resource_id = window.RESOURCE.id;
    }

    var candidateIds = this.getCandidateIds();
    if (candidateIds) {
      params.candidate_ids = candidateIds;
    }

    return jQuery.param(params);
  }

  getReportType() {
    return this.$container.find("[name=report-metric]:checked").val();
  }

  getDateRange() {
    return JSON.parse(this.$dateInput.val());
  }

  getCandidateIds() {
    return jQuery.map(this.options.candidates, function (_name, id) {
      return id;
    });
  }
}

window.ReportsManager = ReportsManager;
